/* PM gift-wrap option (W1, 2026-08-05). Saves cart attributes via /cart/update.js.
   C143, 5 Nov 2026: a tick or message can no longer be lost to a quick tap on Checkout. The save survives the page leaving
   (keepalive), Checkout waits for it up to 1.5 s and then goes regardless, and a failed tick unticks so the customer can see it.
   Custom PM code: re-apply after Symmetry theme updates. */
if (!customElements.get('gift-option')) {
  let pending = Promise.resolve();
  let inFlight = 0;

  class GiftOption extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('[data-gift-checkbox]');
      this.msgWrap = this.querySelector('[data-gift-message-wrap]');
      this.msg = this.querySelector('[data-gift-message]');
      if (!this.checkbox) return;
      this.checkbox.addEventListener('change', () => {
        this.msgWrap.classList.toggle('hidden', !this.checkbox.checked);
        this.save();
      });
      this.msg.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.save(), 600);
      });
      this.msg.addEventListener('blur', () => this.flush());
    }
    flush() {
      if (this.timer) this.save();
    }
    save() {
      clearTimeout(this.timer);
      this.timer = null;
      const ticked = this.checkbox.checked;
      const attributes = {
        'Gift order': ticked ? 'Yes' : '',
        'Gift message': ticked ? this.msg.value.trim() : ''
      };
      inFlight += 1;
      const request = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({ attributes: attributes })
      }).then((response) => {
        if (!response.ok) throw new Error(response.status);
      }).catch(() => {
        if (ticked && this.checkbox.isConnected) {
          this.checkbox.checked = false;
          this.msgWrap.classList.add('hidden');
        }
      }).finally(() => {
        inFlight -= 1;
      });
      pending = Promise.all([pending, request]);
    }
  }
  customElements.define('gift-option', GiftOption);

  document.addEventListener('click', (event) => {
    const target = event.target.closest('a[href$="/checkout"], [name="checkout"]');
    if (!target || target.dataset.giftSaved) return;
    document.querySelectorAll('gift-option').forEach((option) => option.flush());
    if (!inFlight) return;
    event.preventDefault();
    event.stopPropagation();
    const go = () => {
      target.dataset.giftSaved = '1';
      target.click();
      delete target.dataset.giftSaved;
    };
    Promise.race([pending, new Promise((resolve) => { setTimeout(resolve, 1500); })]).then(go, go);
  }, true);
}
